import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFieldTypeNumeric = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 12",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 4H10M2 8H10M4 1.5V10.5M8 1.5V10.5",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFieldTypeNumeric;
